import { render, staticRenderFns } from "./QuickApplyJobdetails.vue?vue&type=template&id=331e4880&scoped=true&"
import script from "./QuickApplyJobdetails.vue?vue&type=script&lang=ts&"
export * from "./QuickApplyJobdetails.vue?vue&type=script&lang=ts&"
import style0 from "./QuickApplyJobdetails.vue?vue&type=style&index=0&id=331e4880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e4880",
  null
  
)

export default component.exports